import { Add, ArrowRight, ArrowRightAlt, Assignment, Close, CloudUploadOutlined, Delete, DeleteForever, DragIndicator, EditOutlined, FilterList, GridView, MoreHoriz, MoreVert, OpenInNew, Search, ViewList, VisibilityOutlined } from '@mui/icons-material'
import { Autocomplete, Avatar, Box, Button, Card, CardContent, Chip, Dialog, FormControl, Grid, IconButton, InputAdornment, InputLabel, MenuItem, Pagination, Paper, Select, Tab, Tabs, TextField, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { FaEdit, FaRegEdit } from "react-icons/fa";
import AddorUpdateProduct from './addorUpdateProduct';
import * as Yup from "yup";
import { Form, Formik } from 'formik';
import { ApiCreateProductImages, ApiCreateVariantImages, ApiCreateVarient, ApiDeleteProduct, ApiDeleteProductImages, ApiDeleteVariant, ApiDeleteVarinatImages, ApiGetAllCategory, ApiGetAllColors, ApiGetAllGender, ApiGetAllSizes, ApiGetVenderProducts, ApiUpdateProduct, ApiUpdateVarient, ApiUploadImage } from '../../Core/Apicall';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { RootState } from '../../Redux/store';
import dayjs from "dayjs";
import { Product } from '../../Models/Products';
import { Variant } from '../../Models/Varient';
// import categories from '../../Categories/categories.json'
import { arrayMove, rectSortingStrategy, SortableContext, useSortable } from '@dnd-kit/sortable';
import { CSS } from "@dnd-kit/utilities";
import { closestCenter, DndContext } from '@dnd-kit/core';



interface Color {
    colorName: string
    colorId: number
    colorCode: number
}
interface Size {
    sizeName: string
    sizeId: number
}


interface AllCategory {
    categoryName: string
    categoryId: number
}

interface AllGender {
    genderName: string
    genderId: number
}




const SortableImage = ({
    item,
    index,
    large = false,
    onDelete,
}: any) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({
        id: item.id || item.media_url || item.image_url,
    });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    return (
        <Box
            ref={setNodeRef}
            style={style}
            sx={{
                position: "relative",
                display: "inline-block",
                width: "100%",
                cursor: "grab",
                "&:hover .delete-btn": {
                    opacity: 1,
                },
            }}
        >
            <IconButton
                {...attributes}
                {...listeners}
                sx={{
                    position: "absolute",
                    bottom: 8,
                    left: 8,
                    zIndex: 10,
                }}
            >
                <DragIndicator />
            </IconButton>
            <Box
                component="img"
                src={item.media_url || item.image_url}
                alt="Preview"
                sx={{
                    width: "100%",
                    height: large ? "auto" : 120,
                    maxHeight: large ? "400px" : undefined,
                    objectFit: large ? "contain" : "cover",
                    borderRadius: 2,
                    border: "1px solid #444",
                }}
            />

            {index === 0 && (
                <Box
                    sx={{
                        position: "absolute",
                        top: 8,
                        left: 8,
                        px: 1,
                        py: 0.5,
                        bgcolor: "var(--third-color)",
                        color: "#fff",
                        borderRadius: 1,
                        fontSize: 12,
                        fontWeight: 600,
                    }}
                >
                    Thumbnail
                </Box>
            )}

            <IconButton
                className="delete-btn"
                onClick={(e) => {
                    e.stopPropagation();
                    onDelete(index);
                }}
                sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    bgcolor: "rgba(0,0,0,0.7)",
                    color: "#fff",
                    opacity: 0,
                    transition: "opacity 0.2s ease",
                    "&:hover": {
                        bgcolor: "error.main",
                    },
                }}
            >
                <Delete />
            </IconButton>
        </Box>
    );
};

function VenderProducts() {
    const [opeaddProduct, setOpenAddProduct] = useState(false)
    const [openEditVarinat, setopenEditVarinat] = useState(false)
    const [openEditProduct, setopenEditProduct] = useState(false)
    const [colorList, setColorList] = useState<Color[]>()
    const [sizeList, setSizeList] = useState<Size[]>()
    const [selectedVariant, setSelectedVariant] = useState<Variant | null>(null);
    const [filterColor, setFilterColor] = useState("")
    const [filterSize, setFilterSize] = useState("")
    const [products, setProducts] = useState<Product[]>([])
    const [selectedProduct, setSelectedProduct] = useState<Product | null>(null)
    const { venderDetails, teamId } = useSelector((state: RootState) => state.global)
    const [page, setPage] = useState(1);
    const limit = 10;
    const [totalProducts, setTotalProducts] = useState(0);
    const [categoryList, setCategoryList] = useState<AllCategory[]>()
    const [genderList, setGenderList] = useState<AllGender[]>()
    const [search, setSearch] = useState("");
    const [selectedCategory, setSelectedCategory] = useState<AllCategory | null>(null);




    const validationSchema = Yup.object({
        colorId: Yup.string().required("Color is required"),

        sizeId: Yup.string().required("Size is required"),

        price: Yup.number()
            .typeError("Price must be a number")
            .required("Price is required")
            .min(0, "Price must be greater than or equal to 0"),

        discount_percentage: Yup.number()
            .min(0, "Discount cannot be less than 0")
            .max(100, "Discount cannot be greater than 100")
            .required("Discount is required"),

        stock: Yup.number()
            .typeError("Stock must be a number")
            .required("Stock is required")
            .min(0, "Stock must be greater than or equal to 0"),

        images: Yup.array()
            .min(1, "At least one image is required")
            .required("Image is required"),
    });

    const getColorList = async () => {
        try {
            const res = await ApiGetAllColors()
            if (res.status || res.success) {
                // console.log("FInal Data", res.data)
                const result = res.data.map((item: any) => ({
                    colorId: item.colorId,
                    colorName: item.name,
                    colorCode: item?.hex_code
                }));

                setColorList(result)
            }
        } catch (error: any) {
            console.log(error)
            toast.error(error?.message || "Something went wrong");
        }
    }


    const getSizeList = async () => {
        try {
            const res = await ApiGetAllSizes()
            if (res.status || res.success) {
                // console.log("FInal Data", res.data)
                const result = res.data.map((item: any) => ({
                    sizeId: item.sizeId,
                    sizeName: item.name,
                }));
                setSizeList(result)
            }
        } catch (error: any) {
            console.log(error)
            toast.error(error?.message || "Something went wrong");
        }
    }


    useEffect(() => {
        getColorList()
        getSizeList()
    }, [])


    const uploadImage = async (file: File) => {
        const payload = new FormData();

        payload.append("images[]", file);
        payload.append("type", "category");

        const res = await ApiUploadImage(payload);

        if (res.status || res.success) {
            return res.data[0].media_url;
        }
        else {
            toast.error(res.message.replace(/<[^>]*>/g, ""))
        }

        return null;
    };


    const handleDelete = async () => {
        const confirm = window.confirm("Are you sure you want to deelte this variant ?")
        if (confirm) {
            try {
                const data = `?variantId=${selectedVariant?.variantId}`
                const res = await ApiDeleteVariant(data)
                if (res?.success) {
                    setSelectedVariant(null)
                    setopenEditVarinat(false)
                }
            } catch (error: any) {
                toast.error(error?.message || "Something went wrong");
            }
        }
    }

    const handleDeleteProduct = async () => {
        const confirm = window.confirm("Are you sure you want to delte this product ?")
        if (confirm) {
            try {
                const data = `?productId=${selectedProduct?.productId}`
                const res = await ApiDeleteProduct(data)
                if (res?.success) {
                    setSelectedProduct(null)
                    setopenEditProduct(false)
                    setPage(1)
                    GetVenderProducts()

                }
            } catch (error: any) {
                toast.error(error?.message || "Something went wrong");
            }
        }
    }

    const GetVenderProducts = async (currentPage = 1) => {

        try {
            const offset = (currentPage - 1) * limit;
            const query = new URLSearchParams({
                shopProfileId: String(venderDetails?.shopProfileId),
                limit: String(limit),
                offset: String(offset),
            });

            if (search.trim()) {
                query.append("searchTerm", search.trim());
            }

            if (selectedCategory) {
                query.append("categoryId", String(selectedCategory?.categoryId));
            }

            const res = await ApiGetVenderProducts(`?${query.toString()}`);

            if (res?.status || res?.success) {
                setProducts(res?.data || []);
                setSelectedProduct(res?.data?.[0] || null);
                setTotalProducts(res?.total || 0);
            }
        } catch (error) {
            console.log("Error", error)
        }
    }

    useEffect(() => {
        if (!opeaddProduct) {
            GetVenderProducts(page);
        }
    }, [page, opeaddProduct]);

    const getCategoryList = async () => {
        try {
            const data = `?isAdmin=true`
            const res = await ApiGetAllCategory(data)
            if (res.status || res.success) {
                const result: any = res?.data.map((item: any) => ({
                    categoryId: item.categoryId,
                    categoryName: item.categoryName,
                }));
                setCategoryList(result)
            }
        } catch (error: any) {
            console.log(error)
            toast.error(error?.message || "Something went wrong");
        }
    }

    const getGenderList = async () => {
        try {
            const res = await ApiGetAllGender()
            if (res.status || res.success) {
                // console.log("FInal Data", res.data)
                const result = res.data.map((item: any) => ({
                    genderId: item.genderId,
                    genderName: item.name,
                }));
                setGenderList(result)
            }
        } catch (error: any) {
            console.log(error)
            toast.error(error?.message || "Something went wrong");
        }
    }

    useEffect(() => {
        getCategoryList()
        getGenderList()
    }, [])

    useEffect(() => {
        const timer = setTimeout(() => {
            GetVenderProducts(1);
        }, 500); // debounce

        return () => clearTimeout(timer);
    }, [search, selectedCategory]);

    const truncateText = (text: string, maxLength = 20) => {
        if (!text) return "";

        return text.length > maxLength
            ? `${text.slice(0, maxLength)}...`
            : text;
    };

    const updateThumbnailImages = (images: any[]) => {
        return images.map((img, index) => ({
            ...img,
            is_thumbnail: index === 0,
        }));
    };



    return (
        <Box className='h-100 p-3' sx={{ minHeight: 'calc(100vh - 65px)' }}>
            <Grid container spacing={1.5} className='h-100'>
                {/* Product Listing */}
                <Grid size={{ xs: 12, md: 6, lg: 4 }} className="bg-main border-10 d-flex flex-column border-main p-2 p-md-3">
                    {/* Header */}
                    <Box className="d-flex justify-content-between align-items-center mb-3">
                        <Box>
                            <Typography
                                className='fs-20 text-white fw-bold'>
                                Products
                            </Typography>
                            <Typography
                                className='text-grey fs-14'>
                                Manage your store products
                            </Typography>
                        </Box>

                        <Button className='btn-yellow px-3' onClick={() => { setOpenAddProduct(true) }} startIcon={<Add />}>
                            Add Product
                        </Button>
                    </Box>
                    <Box className="d-flex form gap-2 mb-3">
                        <TextField
                            sx={{ flex: 1 }}
                            size="small"
                            placeholder="Search products..."
                            value={search}
                            onChange={(e) => {
                                setSearch(e.target.value);
                                setPage(1);
                            }}
                            slotProps={{
                                input: {
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Search className="text-grey" />
                                        </InputAdornment>
                                    ),
                                },
                            }}
                        />

                        <Autocomplete
                            className='autoselect'
                            size="small"
                            sx={{ minWidth: 130 }}
                            options={categoryList || []}
                            value={selectedCategory}
                            getOptionLabel={(option) => option.categoryName || ""}
                            onChange={(_, value) => {
                                setSelectedCategory(value);
                                setPage(1);
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Select Category"
                                />
                            )}
                        />
                    </Box>
                    {products?.length > 0 ? (<Box>

                        {/* Search + Filters */}


                        {/* Tabs */}
                        {/* <Box className="d-flex row  w-100 gap-4 mb-3">
                        <Typography
                            className='text-yellow text-center white-space col fs-14'
                            sx={{
                                borderBottom: "2px solid var(--secondary-color)",
                                pb: 1,
                                cursor: "pointer",
                            }}
                        >
                            All (245)
                        </Typography>

                        <Typography className='text-grey text-center col fs-14'>
                            Active (210)
                        </Typography>

                        <Typography className='text-grey text-center col fs-14'>
                            Draft (12)
                        </Typography>

                        <Typography className='text-grey text-center col fs-14'>
                            Archived (23)
                        </Typography>
                    </Box> */}

                        {/* Product List */}
                        {products?.map((item, index) => (
                            <Card
                                className='border-10 py-0'
                                key={index}
                                sx={{
                                    mb: 1,
                                    background:
                                        selectedProduct?.productId == item?.productId
                                            ? "var(--secondary-light-color)"
                                            : "transparent",
                                    border:
                                        selectedProduct?.productId == item?.productId
                                            ? "1px solid var(--secondary-color)"
                                            : "1px solid var(--text-grey)",
                                }}
                                onClick={() => { setSelectedProduct(item) }}
                            >
                                <CardContent className="d-flex py-2 align-items-center justify-content-between">
                                    <Box className="d-flex align-items-center gap-3">
                                        <Avatar
                                            src={item?.media?.find((media: any) => media?.is_thumbnail)?.media_url}
                                            variant="rounded"
                                            sx={{
                                                width: 42,
                                                height: 42,
                                                objectFit: 'center'

                                            }}
                                        />

                                        <Box>
                                            <Typography
                                                className="text-white fw-semibold fs-14" title={item?.productName}>
                                                {truncateText(item?.productName)}
                                            </Typography>
                                            <Box className='d-flex mt-1 gap-2 align-items-center'>
                                                <Typography
                                                    className='fs-12 text-grey'>
                                                    {item?.category?.categoryName}
                                                </Typography>

                                                <Chip
                                                    className='fs-12 bg-light-green text-green'
                                                    label={item.is_active ? "Active" : "InActive"}
                                                    size="small"
                                                    color="success"
                                                    sx={{ borderRadius: '5px' }}
                                                />
                                            </Box>
                                        </Box>
                                    </Box>

                                    <Box className='text-center'>
                                        <Typography className='fs-12 text-grey'>
                                            Variants
                                        </Typography>

                                        <Typography className="text-white fs-18">
                                            {item?.variants?.length}
                                        </Typography>
                                    </Box>

                                    <Box className='text-center'>
                                        <Typography className='fs-12 text-grey'>
                                            Stock
                                        </Typography>

                                        <Typography className="text-white fs-18">
                                            {item?.totalStock}
                                        </Typography>
                                    </Box>
                                </CardContent>
                            </Card>
                        ))}

                        {/* Pagination */}
                        <Box className="d-flex justify-content-between align-items-center mt-3">
                            <Typography className="fs-12 text-grey">
                                Showing {(page - 1) * limit + 1} to{" "}
                                {Math.min(page * limit, totalProducts)} of {totalProducts} products
                            </Typography>

                            <Pagination
                                count={Math.ceil(totalProducts / limit)}
                                page={page}
                                onChange={(_, value) => setPage(value)}
                                color="secondary"
                                shape="rounded"
                            />
                        </Box>
                    </Box>
                    ) : (<Box className='h-100 d-flex align-items-center justify-content-center'><Typography className='text-white fs-16 mx-auto'>No Products Found</Typography></Box>)}
                </Grid>



                {/* Product Details */}
                <Grid size={{ xs: 12, md: 6, lg: 5 }} className='bg-main border-10 border-main p-2 p-md-3'>
                    <Box sx={{ display: !openEditProduct ? 'flex' : "none" }} className='flex-column h-100'>
                        {/* Header */}
                        <Typography className='text-white fs-20 fw-bold mb-3'>Product Details</Typography>
                        {selectedProduct ? (<Box>
                            <Box className="d-flex justify-content-between align-items-start mb-3">
                                <Box>
                                    <Box className="d-flex align-items-center gap-2">
                                        <Typography className="fs-20 fw-bold text-white" title={selectedProduct?.productName}>
                                            {truncateText(selectedProduct?.productName, 30)}
                                        </Typography>

                                        <Chip
                                            className='text-green bg-light-green'
                                            label={selectedProduct?.is_active ? "Active" : "InActive"}
                                            size="small"
                                            sx={{ borderRadius: '5px' }}
                                        />
                                    </Box>
                                </Box>

                                <Box className="d-flex gap-2">
                                    <Button
                                        onClick={() => { setopenEditProduct(true) }}
                                        className='btn-light-yellow px-3'
                                        startIcon={FaRegEdit({ size: 18, color: 'var(--secondary-color)' })}

                                    >
                                        Edit Product
                                    </Button>
                                    <IconButton className='p-0 m-0' onClick={() => { handleDeleteProduct() }}>
                                        <Delete className='text-danger' />
                                    </IconButton>

                                </Box>
                            </Box>

                            {/* Product Preview */}
                            <Grid container spacing={1} className='align-items-start'>
                                {/* Images */}
                                <Grid size={{ xs: 12, xl: 7 }}>
                                    <Box className="d-flex gap-2 ">
                                        <Box
                                            sx={{
                                                width: 60,
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: 1,
                                            }}
                                        >
                                            {selectedProduct?.media?.filter((media: any) => media?.is_thumbnail == false).map((item: any) => (
                                                <Paper
                                                    key={item}
                                                    sx={{
                                                        height: 60,
                                                    }}
                                                >
                                                    <img
                                                        className='h-100 w-100 border-5'
                                                        src={item?.media_url}
                                                        alt=""
                                                        style={{
                                                            objectFit: "contain",
                                                        }}
                                                    />
                                                </Paper>
                                            ))}
                                        </Box>

                                        <Paper
                                            sx={{
                                                flex: 1,
                                                minHeight: 260,
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                        >
                                            <img
                                                className='h-100 w-100 border-10'
                                                src={selectedProduct?.media?.find((media: any) => media?.is_thumbnail)?.media_url}
                                                alt=""
                                                style={{
                                                    objectFit: "contain",
                                                }}
                                            />
                                        </Paper>
                                    </Box>
                                </Grid>
                                {/* Product Info */}
                                <Grid size={{ xs: 12, xl: 5 }}>
                                    <Paper
                                        className='border-10 border-grey bg-grey'
                                        sx={{
                                            height: "100%",
                                            p: 2,
                                            // bgcolor: "var(--primary-bg-color)",
                                        }}
                                    >
                                        {[
                                            ["Category", selectedProduct?.category?.categoryName],
                                            ["Base Price", `$ ${selectedProduct?.base_price}`],
                                            ["Discount (if any)", `${Number(selectedProduct?.discount_percentage) > 0 ? `${selectedProduct?.discount_percentage} %` : "0"}`],
                                            ["selling Price", `$ ${selectedProduct?.discounted_price ? selectedProduct?.discounted_price : selectedProduct?.base_price}`],
                                            ["Variants", selectedProduct?.variants?.length],
                                            [
                                                "Created At",
                                                selectedProduct?.created_at
                                                    ? dayjs(selectedProduct.created_at).format("DD/MM/YYYY HH:mm")
                                                    : "-"
                                            ],
                                            [
                                                "Updated At",
                                                selectedProduct?.updated_at
                                                    ? dayjs(selectedProduct.updated_at).format("DD/MM/YYYY HH:mm")
                                                    : "-"
                                            ]
                                        ].map(([label, value]) => (
                                            <Box
                                                key={label}
                                                className="d-flex justify-content-between mb-3"
                                            >
                                                <Typography className='text-grey'>
                                                    {label}
                                                </Typography>

                                                <Typography className="text-white">
                                                    {value}
                                                </Typography>
                                            </Box>
                                        ))}
                                    </Paper>
                                </Grid>
                            </Grid>

                            {/* Stats */}
                            <Grid container spacing={1} className="mt-3">
                                {[
                                    ["Total Stock", selectedProduct?.totalStock],
                                    ["Total Sold", selectedProduct?.totalSold],
                                    ["Revenue", `$ ${selectedProduct?.revenue}`],
                                    ["Reviews", selectedProduct?.reviews?.length],
                                ].map(([label, value]) => (
                                    <Grid size={3} key={label}>
                                        <Paper
                                            className='border-10 p-2 px-3 bg-grey'
                                            sx={{
                                                // bgcolor: "var(--primary-bg-color)",
                                                border: "1px solid rgba(255,255,255,.08)",
                                            }}
                                        >
                                            <Typography
                                                className='fs-12 text-grey' gutterBottom>
                                                {label}
                                            </Typography>

                                            <Typography
                                                className="text-white fs-18 fw-bold"
                                            >
                                                {value}
                                            </Typography>
                                        </Paper>
                                    </Grid>
                                ))}
                            </Grid>

                            {/* Tabs */}
                            <Tabs
                                value={0}
                                // className='text-grey'
                                sx={{
                                    mt: 2,
                                    "& .MuiTab-root": {
                                        color: "var(--text-grey)",
                                    },
                                    "& .Mui-selected": {
                                        color: "var(--secondary-color) !important",
                                    },
                                    "& .MuiTabs-indicator": {
                                        background: "var(--secondary-color)",
                                    },
                                }}
                            >
                                <Tab className='transform' label="Overview" />
                                <Tab className='transform' label="Inventory" />
                                <Tab className='transform' label="Orders" />
                                <Tab className='transform' label="Reviews" />
                                <Tab className='transform' label="Analytics" />
                            </Tabs>

                            {/* Content */}
                            <Grid container spacing={2} className="mt-3">
                                <Grid size={12}>
                                    <Paper
                                        className='border-grey border-10 bg-grey'
                                        sx={{
                                            p: 2,
                                            // bgcolor: "var(--primary-bg-color)",
                                            height: "100%",
                                        }}
                                    >
                                        <Typography
                                            className="text-white fw-bold mb-3"
                                        >
                                            Description
                                        </Typography>

                                        <Typography
                                            className='text-grey fs-14'
                                        >
                                            {selectedProduct?.description}
                                        </Typography>
                                    </Paper>
                                </Grid>

                                <Grid size={6} className='d-none'>
                                    <Paper
                                        className='border-grey border-10 bg-grey'
                                        sx={{
                                            p: 2,
                                            // bgcolor: "var(--primary-bg-color)",
                                            height: "100%",
                                        }}
                                    >
                                        <Typography
                                            className="text-white fw-bold mb-3"
                                        >
                                            Product Information
                                        </Typography>

                                        {[
                                            ["SKU", "WW-HJ-2024"],
                                            ["Visibility", "Visible"],
                                            ["Weight", "250 g"],
                                            ["Status", "Active"],
                                        ].map(([label, value]) => (
                                            <Box
                                                key={label}
                                                className="d-flex justify-content-between mb-3"
                                            >
                                                <Typography className='text-grey'>
                                                    {label}
                                                </Typography>

                                                <Typography className="text-white">
                                                    {value}
                                                </Typography>
                                            </Box>
                                        ))}
                                    </Paper>
                                </Grid>
                            </Grid>
                        </Box>
                        ) : (<Box className='d-flex align-items-center  h-100 justify-content-center'><Typography className='text-white fs-16'>No Details Found</Typography></Box>)}
                    </Box>

                    <Box sx={{ display: openEditProduct ? 'inline-block' : "none" }}>
                        <Box className='d-flex mb-2 align-items-center justify-content-between'>
                            <Typography className='fs-20 text-white fw-bold'>Edit Product</Typography>
                            <IconButton onClick={() => { setopenEditProduct(false) }} size="small">
                                <Close className='text-white fs-20' />
                            </IconButton>
                        </Box>
                        {selectedProduct && (<Box className='d-flex align-items-start gap-3 mb-3'>
                            <Avatar
                                className='border-light border-10'
                                variant="rounded"
                                src={selectedProduct?.media?.find((media: any) => media?.is_thumbnail)?.media_url}
                                sx={{
                                    width: 80,
                                    height: 100,
                                }}
                            />
                            <Typography className='fw-bold text-white fs-18 w-50  text-wrap'>{selectedProduct?.productName}</Typography>
                        </Box>
                        )}
                        <Formik
                            validationSchema={Yup.object({
                                productName: Yup.string()
                                    .trim()
                                    .required("Product name is required"),

                                description: Yup.string()
                                    .trim()
                                    .required("Description is required"),

                                categoryId: Yup.number()
                                    .moreThan(0, "Category is required")
                                    .required("Category is required"),

                                base_price: Yup.number()
                                    .typeError("Base price must be a number")
                                    .required("Base price is required")
                                    .min(0, "Base price must be greater than or equal to 0"),

                                discount_percentage: Yup.number()
                                    .min(0, "Discount cannot be less than 0")
                                    .max(100, "Discount cannot be greater than 100")
                                    .required("Discount is required"),

                                genderId: Yup.number()
                                    .moreThan(0, "Gender is required")
                                    .required("Gender is required"),

                                images: Yup.array()
                                    .of(
                                        Yup.object({
                                            alt_text: Yup.string().nullable(),

                                            is_active: Yup.boolean(),

                                            is_thumbnail: Yup.boolean(),

                                            sort_order: Yup.number()
                                                .required("Sort order is required"),

                                            media_url: Yup.string()
                                                .required("Image URL is required"),

                                            media_type: Yup.string()
                                                .required("Media type is required"),
                                        })
                                    )
                                    .min(1, "At least one image is required"),
                            })}

                            enableReinitialize
                            initialValues={{

                                productName: selectedProduct?.productName || "",
                                description: selectedProduct?.description || "",
                                categoryId: selectedProduct?.category?.categoryId || 0,
                                base_price: selectedProduct?.base_price || 0,
                                discount_percentage: selectedProduct?.discount_percentage || 0,
                                discounted_price: Number(Number(selectedProduct?.base_price) - ((Number(selectedProduct?.base_price) * Number(selectedProduct?.discount_percentage)) / 100)) || 0,
                                genderId: Number(selectedProduct?.gender?.genderId) || 0,
                                images:
                                    selectedProduct?.media?.map((item: any, index: number) => ({
                                        alt_text: item?.alt_text || "",
                                        productId: selectedProduct?.productId,
                                        is_active: item?.is_active ?? true,
                                        is_thumbnail: index === 0,
                                        sort_order: item?.sort_order || index + 1,
                                        media_url: item?.media_url || "",
                                        media_type: item?.media_type || "IMAGE",
                                        mediaId: item?.mediaId,
                                        isNew: false

                                    })) || [],
                            }}
                            onSubmit={async (values) => {

                                try {
                                    const params = `?productId=${selectedProduct?.productId}`
                                    const { images, ...productPayload } = values;

                                    const newImages = images.filter((img: any) => img.isNew);
                                    const data2 = {
                                        media: newImages
                                    }

                                    const res = await ApiUpdateProduct(params, productPayload)
                                    const res2 = await ApiCreateProductImages(data2)

                                    if ((res.status || res.success) && (res2?.status || res?.success)) {
                                        setopenEditProduct(false)
                                        GetVenderProducts()
                                    }
                                } catch (error: any) {
                                    console.log("Error", error)
                                    toast.error(error?.message || "Something went wrong");
                                }
                            }}
                        >
                            {({
                                values,
                                errors,
                                touched,
                                handleChange,
                                setFieldValue,
                                handleSubmit,
                            }) => {
                                return (
                                    <Form>
                                        <Grid container spacing={2}>
                                            <Grid className='form' size={12}>
                                                <InputLabel className='fs-14 mb-2'>Product Name</InputLabel>
                                                <TextField
                                                    fullWidth
                                                    name="productName"
                                                    type="text"
                                                    value={values.productName}
                                                    onChange={handleChange}
                                                    error={touched.productName && Boolean(errors.productName)}
                                                    helperText={touched.productName ? String(errors.productName || "") : ""}
                                                />
                                            </Grid>
                                            <Grid className='form' size={12}>
                                                <InputLabel className='fs-14 mb-2'>Description</InputLabel>
                                                <TextField
                                                    fullWidth
                                                    name="description"
                                                    type="text"
                                                    multiline
                                                    minRows={4}
                                                    value={values.description}
                                                    onChange={handleChange}
                                                    error={touched.description && Boolean(errors.description)}
                                                    helperText={touched.description ? String(errors.description || "") : ""}
                                                />
                                            </Grid>
                                            <Grid className='form' size={6}>
                                                <InputLabel className='fs-14 mb-2'>Base Price (AUD)</InputLabel>
                                                <TextField
                                                    fullWidth
                                                    name="price"
                                                    type="number"
                                                    value={values.base_price}
                                                    onChange={(e: any) => {
                                                        if (e.target.value < 0) return;
                                                        const basePrice = Number(e.target.value);
                                                        const discount = Number(values.discount_percentage);

                                                        const discountedPrice =
                                                            basePrice - (basePrice * discount) / 100;

                                                        setFieldValue("base_price", e.target.value);
                                                        if (basePrice && discount) {
                                                            setFieldValue(
                                                                "discounted_price",
                                                                discountedPrice.toFixed(2)
                                                            );
                                                        }
                                                    }}
                                                    error={touched.base_price && Boolean(errors.base_price)}
                                                    helperText={touched.base_price ? String(errors.base_price || "") : ""}
                                                    slotProps={{
                                                        input: {
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <span className='text-white'>$</span>
                                                                </InputAdornment>
                                                            ),
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                            <Grid className='form' size={6}>
                                                <InputLabel className='fs-14 mb-2'>Discount (is any)</InputLabel>
                                                <TextField
                                                    fullWidth
                                                    name="price"
                                                    type="number"
                                                    value={values.discount_percentage}
                                                    onChange={(e: any) => {
                                                        if (e.target.value < 0) return;
                                                        const discount = Number(e.target.value);
                                                        const basePrice = Number(values.base_price);

                                                        const discountedPrice =
                                                            basePrice - (basePrice * discount) / 100;

                                                        setFieldValue("discount_percentage", e.target.value);
                                                        if (basePrice && discount) {
                                                            setFieldValue(
                                                                "discounted_price",
                                                                discountedPrice.toFixed(2)
                                                            );
                                                        }
                                                    }}
                                                    error={touched.base_price && Boolean(errors.base_price)}
                                                    helperText={touched.base_price ? String(errors.base_price || "") : ""}
                                                    slotProps={{
                                                        input: {
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <span className='text-white'>%</span>
                                                                </InputAdornment>
                                                            ),
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                            <Grid className='form' size={12}>
                                                <InputLabel className='fs-14 mb-2'>Selling price</InputLabel>
                                                <TextField
                                                    fullWidth
                                                    name="price"
                                                    type="number"
                                                    value={values.discounted_price}
                                                    disabled
                                                    slotProps={{
                                                        input: {
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <span className='text-white'>$</span>
                                                                </InputAdornment>
                                                            ),
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                            <Grid className='form' size={6}>
                                                <InputLabel className='fs-14 mb-2'>Category</InputLabel>
                                                <TextField
                                                    fullWidth
                                                    select
                                                    name="categoryId"
                                                    value={values.categoryId}
                                                    onChange={handleChange}
                                                    error={touched.base_price && Boolean(errors.base_price)}
                                                    helperText={touched.base_price ? String(errors.base_price || "") : ""}
                                                >
                                                    <MenuItem value="">Select Category</MenuItem>

                                                    {categoryList?.map((category: AllCategory) => (
                                                        <MenuItem key={category.categoryId} value={category.categoryId}>
                                                            {category.categoryName}
                                                        </MenuItem>
                                                    ))}
                                                </TextField>
                                            </Grid>
                                            <Grid className='form' size={6}>
                                                <InputLabel className='fs-14 mb-2'>Gender</InputLabel>
                                                <TextField
                                                    fullWidth
                                                    select
                                                    name="genderId"
                                                    value={values.genderId}
                                                    onChange={handleChange}
                                                    error={touched.genderId && Boolean(errors.genderId)}
                                                    helperText={touched.genderId ? String(errors.genderId || "") : ""}
                                                >
                                                    <MenuItem value="">Select Gender</MenuItem>

                                                    {genderList?.map((gender: AllGender) => (
                                                        <MenuItem key={gender?.genderId} value={gender?.genderId}>
                                                            {gender?.genderName}
                                                        </MenuItem>
                                                    ))}
                                                </TextField>
                                            </Grid>
                                            <Grid size={5}>
                                                <Box>
                                                    <Typography className="text-white fs-14 text-grey fw-medium mb-2">
                                                        Logo Image *
                                                    </Typography>

                                                    <Box
                                                        className='border-10 position-relative  pointer overflow-hidden d-flex align-items-center justify-content-center'
                                                        component="label"
                                                        sx={{
                                                            height: 120,
                                                            width: 120,
                                                            border: "2px dashed var(--text-grey)",
                                                            transition: "all .3s ease",

                                                            "&:hover": {
                                                                borderColor: "#fff",
                                                                backgroundColor: "rgba(255,255,255,0.05)",
                                                            },
                                                        }}
                                                    >
                                                        <input
                                                            hidden
                                                            type="file"
                                                            multiple
                                                            accept="image/*"
                                                            onChange={async (e) => {
                                                                try {
                                                                    const files = Array.from(e.target.files || []);

                                                                    const uploadedImages = await Promise.all(
                                                                        files.map((file) => uploadImage(file))
                                                                    );
                                                                    const currentImages = values.images || [];
                                                                    // console.log("Uploaded Images", updatedImages)

                                                                    const newImages = uploadedImages
                                                                        .filter(Boolean)
                                                                        .map((url, index) => ({
                                                                            productId: selectedProduct?.productId,
                                                                            media_url: url,
                                                                            is_active: true,
                                                                            sort_order: currentImages.length + index + 1,
                                                                            is_thumbnail:
                                                                                currentImages.length === 0 && index === 0,
                                                                            alt_text: `Product_Image_${currentImages.length + index + 1}`,
                                                                            media_type: "IMAGE",
                                                                            isNew: true
                                                                        }));

                                                                    // setFieldValue("images", [
                                                                    //     ...currentImages,
                                                                    //     ...newImages,
                                                                    // ]);

                                                                    const updatedImages = updateThumbnailImages([
                                                                        ...currentImages,
                                                                        ...newImages,
                                                                    ]);

                                                                    setFieldValue("images", updatedImages);

                                                                    e.target.value = "";
                                                                } catch (error: any) {
                                                                    toast.error(error.message);
                                                                }
                                                            }}
                                                        />
                                                        <Box
                                                            className='text-center text-white'
                                                        >
                                                            <Add
                                                                className='fs-32'
                                                            />

                                                            <Typography className='fs-14 fw-bold'>
                                                                Add Image
                                                            </Typography>

                                                        </Box>

                                                    </Box>
                                                </Box>
                                            </Grid>
                                            <Grid size={12}>
                                                <Grid container spacing={1.5} className='h-content'>
                                                    {values.images?.[0]?.media_url && (
                                                        <Grid size={6} className='h-content'>
                                                            <Box
                                                                sx={{
                                                                    position: "relative",
                                                                    display: "inline-block",
                                                                    width: "100%",
                                                                    "&:hover .delete-btn": {
                                                                        opacity: 1,
                                                                    },
                                                                }}
                                                            >
                                                                <Box
                                                                    component="img"
                                                                    src={values.images?.[0]?.media_url}
                                                                    alt="Preview"
                                                                    sx={{
                                                                        width: "100%",
                                                                        height: "auto",
                                                                        maxHeight: '400px',
                                                                        objectFit: "contain",
                                                                        borderRadius: 2,
                                                                        border: "1px solid #444",
                                                                    }}
                                                                />

                                                                <IconButton
                                                                    className="delete-btn"
                                                                    onClick={async () => {
                                                                        const image = values.images[0];
                                                                        if (!image.isNew) {
                                                                            const data = `?mediaId=${image.mediaId}`
                                                                            await ApiDeleteProductImages(data);
                                                                        }

                                                                        const updatedMedia = [...values.images];
                                                                        updatedMedia.splice(0, 1); // remove first image
                                                                        // setFieldValue(`images`, updatedMedia);

                                                                        const finalImages = updateThumbnailImages(updatedMedia);
                                                                        setFieldValue("images", finalImages);
                                                                    }}
                                                                    sx={{
                                                                        position: "absolute",
                                                                        top: 8,
                                                                        right: 8,
                                                                        bgcolor: "rgba(0,0,0,0.7)",
                                                                        color: "#fff",
                                                                        opacity: 0,
                                                                        transition: "opacity 0.2s ease",
                                                                        "&:hover": {
                                                                            bgcolor: "error.main",
                                                                        },
                                                                    }}
                                                                >
                                                                    <Delete />
                                                                </IconButton>
                                                            </Box>

                                                        </Grid>
                                                    )}
                                                    <Grid size={6} className='h-content'>
                                                        <Grid container spacing={1}>
                                                            {values.images?.map(
                                                                (item: any, index: number) => index > 0 && (
                                                                    item?.media_url && (
                                                                        <Grid size={6}>
                                                                            <Box
                                                                                sx={{
                                                                                    position: "relative",
                                                                                    display: "inline-block",
                                                                                    width: "100%",
                                                                                    "&:hover .delete-btn": {
                                                                                        opacity: 1,
                                                                                    },
                                                                                }}
                                                                            >
                                                                                <Box
                                                                                    component="img"
                                                                                    src={item.media_url}
                                                                                    alt="Preview"
                                                                                    sx={{
                                                                                        width: "100%",
                                                                                        height: 120,
                                                                                        objectFit: "cover",
                                                                                        borderRadius: 2,
                                                                                        border: "1px solid #444",
                                                                                    }}
                                                                                />
                                                                                <IconButton
                                                                                    className="delete-btn"
                                                                                    onClick={async () => {
                                                                                        const image = values.images[index];
                                                                                        if (!image.isNew) {
                                                                                            const data = `?mediaId=${image.mediaId}`
                                                                                            await ApiDeleteProductImages(data);
                                                                                        }
                                                                                        const updatedMedia = [...values.images];
                                                                                        updatedMedia.splice(index, 1); // remove first image

                                                                                        // setFieldValue(`variants.${index}.images`, updatedMedia);
                                                                                        const finalImages = updateThumbnailImages(updatedMedia);
                                                                                        setFieldValue("images", finalImages);
                                                                                    }}
                                                                                    sx={{
                                                                                        position: "absolute",
                                                                                        top: 8,
                                                                                        right: 8,
                                                                                        bgcolor: "rgba(0,0,0,0.7)",
                                                                                        color: "#fff",
                                                                                        opacity: 0,
                                                                                        transition: "opacity 0.2s ease",
                                                                                        "&:hover": {
                                                                                            bgcolor: "error.main",
                                                                                        },
                                                                                    }}
                                                                                >
                                                                                    <Delete />
                                                                                </IconButton>
                                                                            </Box>
                                                                        </Grid>
                                                                    )
                                                                )
                                                            )}
                                                        </Grid>
                                                    </Grid>

                                                </Grid>
                                            </Grid>
                                            <Grid size={12}>
                                                <Grid container spacing={2}>
                                                    {selectedProduct && openEditProduct && (
                                                        <Grid size={6}>
                                                            <Button fullWidth variant='outlined' startIcon={<Delete />} onClick={() => { handleDeleteProduct() }} className='transform btn-danger'>
                                                                Delete Product
                                                            </Button>
                                                        </Grid>
                                                    )}
                                                    <Grid size={6} className='ms-auto'>
                                                        <Button fullWidth variant='outlined' type='submit' endIcon={<ArrowRightAlt />} className='transform btn-yellow'>
                                                            Save Changes
                                                            {/* {selectedProduct && openEditProduct ? "Save Chnages" : "Add Veriant"} */}
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Form>
                                )
                            }}
                        </Formik>
                    </Box>

                </Grid>




                {/* Varient Details */}
                <Grid size={{ xs: 12, md: 6, lg: 3 }} className='bg-main border-10   border-main p-2 p-md-3'>
                    <Box sx={{ display: openEditVarinat ? 'none' : "flex" }} className='h-100 flex-column'>
                        {(selectedProduct && selectedProduct?.variants?.length > 0) ? (
                            <Box className='h-100 w-100'>
                                <Box className="d-flex justify-content-between align-items-center mb-3">
                                    <Typography className="fs-20 fw-bold text-white">
                                        Variants {selectedProduct?.variants && `(${selectedProduct?.variants?.length})`}
                                    </Typography>

                                    <Box className="d-flex align-items-center gap-2">
                                        <Button
                                            size="small"
                                            variant="outlined"
                                            startIcon={<Add />}
                                            sx={{
                                                color: "#f8b400",
                                                borderColor: "#f8b400",
                                                textTransform: "none",
                                            }}
                                            onClick={() => { setopenEditVarinat(true) }}
                                        >
                                            Add Variant
                                        </Button>

                                        {/* <IconButton size="small">
                                    <Close className='text-white fs-20' />
                                </IconButton> */}
                                    </Box>

                                </Box>

                                {/* Filters */}
                                <Box className="d-flex gap-2 form mb-3">
                                    <FormControl size="small" fullWidth>
                                        <select
                                            className="bg-transparent h-100 text-white border-main  ps-2 py-2  fs-12"
                                            value={filterColor}
                                            onChange={(e) => { setFilterColor(e.target.value) }}
                                            style={{ borderRadius: '5px' }}
                                        >
                                            <option value="">All Colors</option>
                                            {colorList?.map((item) => (
                                                <option value={item?.colorId} key={item.colorId}>{item.colorName}</option>

                                            ))}
                                        </select>
                                    </FormControl>

                                    <FormControl size="small" fullWidth>
                                        <select
                                            className="bg-transparent h-100 text-white border-main  ps-2 py-2  fs-12"
                                            value={filterSize}
                                            onChange={(e) => { setFilterSize(e.target.value) }}
                                            style={{ borderRadius: '5px' }}
                                        >
                                            <option value="">All Sizes</option>
                                            {sizeList?.map((item) => (
                                                <option value={item?.sizeId} key={item.sizeId}>{item.sizeName}</option>

                                            ))}
                                        </select>
                                    </FormControl>
                                </Box>

                                {/* Variant Cards */}
                                <Box sx={{ flex: 1 }}>
                                    <Grid container spacing={1}>
                                        {selectedProduct?.variants?.filter((item: any) => {
                                            const colorMatch = filterColor
                                                ? item.color?.colorId == filterColor
                                                : true;

                                            const sizeMatch = filterSize
                                                ? item.size?.sizeId == filterSize
                                                : true;

                                            return colorMatch && sizeMatch;
                                        })
                                            ?.map((variant, index) => (
                                                <Grid size={{xs:12,xl:6}} key={index}>
                                                    <Paper
                                                        className='bg-grey'
                                                        sx={{
                                                            p: 1.2,
                                                            // bgcolor: "var(--primary-bg-color)",
                                                            border:
                                                                "1px solid rgba(255,255,255,.08)",
                                                            borderRadius: 2,
                                                            height: 'fit-content'
                                                        }}
                                                    >
                                                        <Box className="d-flex gap-2">
                                                            <Avatar
                                                                variant="rounded"
                                                                src={variant?.variantImages?.[0]?.image_url}
                                                                sx={{
                                                                    width: 36,
                                                                    height: 36,
                                                                    objectFit: 'center center'

                                                                }}
                                                            />

                                                            <Box sx={{ flex: 1 }}>
                                                                <Typography
                                                                    className="text-white fs-14 fw-semibold"
                                                                    title={variant.name}
                                                                >
                                                                    {truncateText(variant.name, 20)}
                                                                </Typography>

                                                                <Typography className='fs-12 text-yellow'
                                                                >
                                                                    {variant.sku}
                                                                </Typography>
                                                            </Box>
                                                        </Box>

                                                        <Typography
                                                            className='fs-12 text-grey mt-1'>
                                                            Stock: <span className='text-white fw-bold fs-14'>{variant.stock}</span>
                                                        </Typography>

                                                        <Box className="d-flex justify-content-between align-items-center mt-1">
                                                            <Typography className="text-white fs-16 fw-bold">
                                                                ${variant.discounted_price}
                                                            </Typography>

                                                            <IconButton
                                                                size="small"
                                                                onClick={() => { setSelectedVariant(variant); setopenEditVarinat(true) }}
                                                            >
                                                                <OpenInNew className='text-grey' fontSize="small" />
                                                            </IconButton>
                                                        </Box>
                                                    </Paper>

                                                </Grid>
                                            ))}
                                    </Grid>
                                </Box>

                                <Box sx={{ flexWrap: 'wrap' }} className="d-flex flex-column flex-wrap w-100 justify-content-between align-items-center mt-3">
                                    <Typography className='fs-12 text-end  text-grey'>
                                        Showing 1 to 10 of 245 products
                                    </Typography>
                                    <Pagination
                                        className='text-white w-100'
                                        // sx={{color:'white !important'}}
                                        count={49}
                                        page={1}
                                        color="secondary"
                                        shape="rounded"
                                    />
                                </Box>
                            </Box>
                        ) : (<Box className='h-100 d-flex align-items-center justify-content-center'><Typography className='text-white fs-16'>No Variants found </Typography></Box>)}
                    </Box>
                    <Box sx={{ display: openEditVarinat ? 'inline-block' : "none" }}>
                        <Box className='d-flex mb-2 align-items-center justify-content-between'>
                            <Typography className='fs-20 text-white fw-bold'>{selectedVariant ? "Edit" : "Add"} Varient</Typography>
                            <IconButton onClick={() => { setopenEditVarinat(false); setSelectedVariant(null) }} size="small">
                                <Close className='text-white fs-20' />
                            </IconButton>
                        </Box>
                        {selectedVariant && (<Box className='d-flex align-items-start gap-3 mb-3'>
                            <Avatar
                                className='border-light border-10'
                                variant="rounded"
                                src={selectedVariant?.variantImages?.[0]?.image_url}
                                sx={{
                                    width: 80,
                                    height: 100,
                                }}
                            />
                            <Typography className='fw-bold text-white fs-18'>{selectedVariant?.name} <span className='fs-12 py-2 px-3 border-5 text-green bg-light-green'>Active</span></Typography>
                        </Box>
                        )}
                        <Formik
                            validationSchema={validationSchema}
                            enableReinitialize
                            initialValues={{
                                colorId: selectedVariant?.color?.colorId || "",
                                sizeId: selectedVariant?.size?.sizeId || "",
                                price: selectedVariant?.price || "",
                                stock: selectedVariant?.stock || "",
                                discount_percentage: selectedVariant?.discount_percentage || "",
                                discounted_price: Number(Number(selectedVariant?.price) - ((Number(selectedVariant?.price) * Number(selectedVariant?.discount_percentage)) / 100)) || 0,
                                images:
                                    selectedVariant?.variantImages?.map((item: any, index: number) => ({
                                        alt_text: item?.alt_text || "",
                                        image_url: item?.image_url || "",
                                        is_active: item?.is_active ?? true,
                                        is_thumbnail: item?.is_thumbnail || false,
                                        sort_order: item?.sort_order || index + 1,
                                        variantImageId: item?.variantImageId,
                                        isNew: false
                                    })) || [],
                            }}
                            onSubmit={async (values) => {

                                try {
                                    const params = `?variantId=${selectedVariant?.variantId}`
                                    const { images, ...productPayload } = values;
                                    const newImages = images.filter((img: any) => img.isNew);
                                    const createPayload = { productId: selectedProduct?.productId, ...productPayload }
                                    const data2 = {
                                        images: newImages
                                    }

                                    const res = selectedVariant ? await ApiUpdateVarient(params, productPayload) : await ApiCreateVarient({ ...createPayload, ...data2 })
                                    const res2 = selectedVariant && await ApiCreateVariantImages(data2)
                                    if (res?.success || res2?.success) {
                                        setSelectedVariant(null)
                                        setopenEditVarinat(false)
                                        GetVenderProducts()
                                    }
                                } catch (error: any) {
                                    console.log("Error", error)
                                    toast.error(error?.message || "Something went wrong");
                                }
                            }}


                        >
                            {({
                                values,
                                errors,
                                touched,
                                handleChange,
                                setFieldValue,
                                handleSubmit,
                            }) => {

                                const handleVariantImageDrag = (
                                    // variantIndex: number,
                                    event: any,
                                    values: any,
                                    setFieldValue: any
                                ) => {

                                    const { active, over } = event;

                                    if (!over || active.id === over.id) return;

                                    const images = values.images || [];

                                    const oldIndex = images.findIndex(
                                        (i: any) =>
                                            (i.id || i.image_url) === active.id
                                    );

                                    const newIndex = images.findIndex(
                                        (i: any) =>
                                            (i.id || i.image_url) === over.id
                                    );

                                    const reordered = arrayMove(images, oldIndex, newIndex).map(
                                        (img: any, idx: number) => ({
                                            ...img,
                                            sort_order: idx + 1,
                                            is_thumbnail: idx === 0,
                                        })
                                    );

                                    setFieldValue(
                                        `images`,
                                        reordered
                                    );
                                };
                                return (
                                    <Form>
                                        <Grid container spacing={2}>
                                            <Grid className='custom-toggle' size={12}>
                                                <Typography className="text-white fs-14 fw-bold mb-2">
                                                    Color
                                                </Typography>

                                                <ToggleButtonGroup
                                                    exclusive
                                                    value={values.colorId}
                                                    onChange={(_, value) => {
                                                        if (value) {
                                                            setFieldValue("colorId", value);
                                                        }
                                                    }}
                                                    sx={{
                                                        display: "flex",
                                                        gap: 1,
                                                        flexWrap: "wrap",

                                                        "& .MuiToggleButton-root": {
                                                            gap: 1,
                                                        },

                                                    }}
                                                >
                                                    <Grid container className='w-100 flex-wrap' spacing={1.5}>
                                                        {colorList?.map((item: Color) => (
                                                            <Grid size={'auto'}>
                                                                <ToggleButton key={item?.colorId} value={item.colorId}>
                                                                    <Box
                                                                        sx={{
                                                                            width: 14,
                                                                            height: 14,
                                                                            borderRadius: "50%",
                                                                            background: item.colorCode,
                                                                            border: "2px solid #666",
                                                                        }}
                                                                    />
                                                                    <span>{item?.colorName}</span>
                                                                </ToggleButton>
                                                            </Grid>

                                                        ))}
                                                    </Grid>
                                                    <ToggleButton value="add">
                                                        + Add Color
                                                    </ToggleButton>
                                                </ToggleButtonGroup>
                                            </Grid>
                                            <Grid className='custom-toggle' size={12}>
                                                <Typography className="text-white fs-14 fw-bold mb-2">
                                                    Size
                                                </Typography>

                                                <ToggleButtonGroup
                                                    exclusive
                                                    value={values.sizeId}
                                                    onChange={(_, value) => {
                                                        if (value) {
                                                            setFieldValue("sizeId", value);
                                                        }
                                                    }}
                                                    sx={{
                                                        display: "flex",
                                                        gap: 1,
                                                        flexWrap: "wrap",

                                                        "& .MuiToggleButton-root": {
                                                            gap: 1,
                                                        },

                                                    }}
                                                >
                                                    <Grid container className='w-100 flex-wrap' spacing={1.5}>
                                                        {sizeList?.map((item: Size) => (
                                                            <Grid size={'auto'}>
                                                                <ToggleButton key={item?.sizeId} value={item?.sizeId}>
                                                                    <Assignment className='fs-14 p-0 m-0' />
                                                                    {item?.sizeName}
                                                                </ToggleButton>
                                                            </Grid>

                                                        ))}

                                                    </Grid>

                                                    <ToggleButton value="add">
                                                        + Add Size
                                                    </ToggleButton>
                                                </ToggleButtonGroup>
                                            </Grid>
                                            <Grid className="form" size={6}>
                                                <InputLabel className="fs-14 mb-2">
                                                    Price ($)
                                                </InputLabel>

                                                <TextField
                                                    fullWidth
                                                    name="price"
                                                    type="number"
                                                    value={values.price}
                                                    onChange={(e: any) => {
                                                        if (e.target.value < 0) return;
                                                        const price = Number(e.target.value);
                                                        const discountPercentage = Number(values.discount_percentage || 0);

                                                        const discountedPrice =
                                                            price - (price * discountPercentage) / 100;

                                                        setFieldValue("price", e.target.value);
                                                        setFieldValue(
                                                            "discounted_price",
                                                            discountedPrice.toFixed(2)
                                                        );
                                                    }}
                                                    error={touched.price && Boolean(errors.price)}
                                                    helperText={touched.price ? String(errors.price || "") : ""}
                                                    slotProps={{
                                                        input: {
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <span className='text-white'>$</span>
                                                                </InputAdornment>
                                                            ),

                                                        },
                                                    }}
                                                />
                                            </Grid>

                                            {/* Discount Percentage */}
                                            <Grid className="form" size={6}>
                                                <InputLabel className="fs-14 mb-2">
                                                    Discount (if any)
                                                </InputLabel>

                                                <TextField
                                                    fullWidth
                                                    name="discount_percentage"
                                                    type="number"
                                                    value={values.discount_percentage}
                                                    onChange={(e: any) => {
                                                        if (e.target.value < 0) return;
                                                        const discountPercentage = Number(e.target.value);
                                                        const price = Number(values.price || 0);

                                                        const discountedPrice =
                                                            price - (price * discountPercentage) / 100;

                                                        setFieldValue(
                                                            "discount_percentage",
                                                            e.target.value
                                                        );

                                                        setFieldValue(
                                                            "discounted_price",
                                                            discountedPrice.toFixed(2)
                                                        );
                                                    }}
                                                    error={
                                                        touched.discount_percentage &&
                                                        Boolean(errors.discount_percentage)
                                                    }
                                                    helperText={
                                                        touched.discount_percentage
                                                            ? String(errors.discount_percentage || "")
                                                            : ""
                                                    }
                                                    slotProps={{

                                                        input: {
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <span className='text-white'>%</span>
                                                                </InputAdornment>
                                                            ),
                                                        },
                                                    }}
                                                />
                                            </Grid>

                                            {/* Selling Price */}
                                            <Grid className="form" size={6}>
                                                <InputLabel className="fs-14 mb-2">
                                                    Selling Price ($)
                                                </InputLabel>

                                                <TextField
                                                    fullWidth
                                                    name="discounted_price"
                                                    type="number"
                                                    value={values.discounted_price}
                                                    disabled
                                                    error={
                                                        touched.discounted_price &&
                                                        Boolean(errors.discounted_price)
                                                    }
                                                    helperText={
                                                        touched.discounted_price
                                                            ? String(errors.discounted_price || "")
                                                            : ""
                                                    }
                                                    slotProps={{
                                                        input: {
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <span className='text-white'>$</span>
                                                                </InputAdornment>
                                                            ),
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                            <Grid className='form' size={12}>
                                                <InputLabel className='fs-14 mb-2'>Stock</InputLabel>
                                                <TextField
                                                    fullWidth
                                                    name="stock"
                                                    type="number"
                                                    value={values.stock}
                                                    onChange={handleChange}
                                                    error={touched.stock && Boolean(errors.stock)}
                                                    helperText={
                                                        touched.stock && typeof errors.stock === "string"
                                                            ? errors.stock
                                                            : ""
                                                    }
                                                />
                                            </Grid>
                                            <Grid size={5}>
                                                <Box>
                                                    <Typography className="text-white fs-14 text-grey fw-medium mb-2">
                                                        Logo Image *
                                                    </Typography>

                                                    <Box
                                                        className='border-10 position-relative  pointer overflow-hidden d-flex align-items-center justify-content-center'
                                                        component="label"
                                                        sx={{
                                                            height: 120,
                                                            width: 120,
                                                            border: "2px dashed var(--text-grey)",
                                                            transition: "all .3s ease",

                                                            "&:hover": {
                                                                borderColor: "#fff",
                                                                backgroundColor: "rgba(255,255,255,0.05)",
                                                            },
                                                        }}
                                                    >
                                                        <input
                                                            hidden
                                                            type="file"
                                                            accept="image/*"
                                                            multiple
                                                            onChange={async (e) => {
                                                                try {
                                                                    const files = Array.from(e.target.files || []);

                                                                    const uploadedImages = await Promise.all(
                                                                        files.map((file) => uploadImage(file))
                                                                    );
                                                                    const currentImages = values.images || [];

                                                                    const newImages = uploadedImages
                                                                        .filter(Boolean)
                                                                        .map((url, index) => ({
                                                                            image_url: url,
                                                                            is_active: true,
                                                                            variantId: selectedVariant?.variantId,
                                                                            sort_order: currentImages.length + index + 1,
                                                                            is_thumbnail:
                                                                                currentImages.length === 0 && index === 0,
                                                                            alt_text: `Variant_Image_${currentImages.length + index + 1}`,
                                                                            isNew: true,
                                                                        }));

                                                                    setFieldValue("images", [...currentImages, ...newImages]);

                                                                    e.target.value = "";
                                                                } catch (error: any) {
                                                                    toast.error(error.message);
                                                                }
                                                            }}
                                                        />
                                                        <Box
                                                            className='text-center text-white'
                                                        >
                                                            <Add
                                                                className='fs-32'
                                                            />

                                                            <Typography className='fs-14 fw-bold'>
                                                                Add Image
                                                            </Typography>

                                                        </Box>

                                                    </Box>
                                                </Box>
                                            </Grid>
                                            <Grid size={12}>
                                                {values.images?.length > 0 && (
                                                    <DndContext
                                                        collisionDetection={closestCenter}
                                                        onDragEnd={(event) =>
                                                            !selectedVariant && handleVariantImageDrag(
                                                                event,
                                                                values,
                                                                setFieldValue
                                                            )
                                                        }
                                                    >
                                                        <SortableContext
                                                            items={values.images.map(
                                                                (i: any) => i.id || i.image_url
                                                            )}
                                                            strategy={rectSortingStrategy}
                                                        >
                                                            <Grid container spacing={1.5} className='h-content'>
                                                                {/* {values.images?.[0]?.image_url && (
                                                                <Grid size={6} className='h-content'>
                                                                    <Box
                                                                        sx={{
                                                                            position: "relative",
                                                                            display: "inline-block",
                                                                            width: "100%",
                                                                            "&:hover .delete-btn": {
                                                                                opacity: 1,
                                                                            },
                                                                        }}
                                                                    >
                                                                        <Box
                                                                            component="img"
                                                                            src={values.images?.[0]?.image_url}
                                                                            alt="Preview"
                                                                            sx={{
                                                                                width: "100%",
                                                                                height: "auto",
                                                                                maxHeight: '400px',
                                                                                objectFit: "contain",
                                                                                borderRadius: 2,
                                                                                border: "1px solid #444",
                                                                            }}
                                                                        />

                                                                        <IconButton
                                                                            className="delete-btn"
                                                                            onClick={async () => {
                                                                                const image = values.images[0];
                                                                                const data = `?variantImageId= ${values.images?.[0]?.variantImageId}`
                                                                                if (!image.isNew) {
                                                                                    await ApiDeleteVarinatImages(data);
                                                                                }
                                                                                const updatedMedia = [...values.images];
                                                                                updatedMedia.splice(0, 1); // remove first image

                                                                                // setFieldValue(`images`, updatedMedia);
                                                                                const finalImages = updateThumbnailImages(updatedMedia);
                                                                                setFieldValue("images", finalImages);
                                                                            }}
                                                                            sx={{
                                                                                position: "absolute",
                                                                                top: 8,
                                                                                right: 8,
                                                                                bgcolor: "rgba(0,0,0,0.7)",
                                                                                color: "#fff",
                                                                                opacity: 0,
                                                                                transition: "opacity 0.2s ease",
                                                                                "&:hover": {
                                                                                    bgcolor: "error.main",
                                                                                },
                                                                            }}
                                                                        >
                                                                            <Delete />
                                                                        </IconButton>
                                                                    </Box>

                                                                </Grid>
                                                            )} */}
                                                                {values.images.map(
                                                                    (item: any, imgIndex: number) => (
                                                                        <Grid
                                                                            key={item.image_url}
                                                                            size={imgIndex === 0 ? 6 : 3}
                                                                        >
                                                                            <SortableImage
                                                                                item={item}
                                                                                index={imgIndex}
                                                                                large={imgIndex === 0}
                                                                                onDelete={(i: number) => {
                                                                                    const updated = [
                                                                                        ...values.images,
                                                                                    ];

                                                                                    updated.splice(i, 1);

                                                                                    const normalized =
                                                                                        updated.map(
                                                                                            (img, idx) => ({
                                                                                                ...img,
                                                                                                sort_order: idx + 1,
                                                                                                is_thumbnail:
                                                                                                    idx === 0,
                                                                                            })
                                                                                        );

                                                                                    setFieldValue(
                                                                                        `images`,
                                                                                        normalized
                                                                                    );
                                                                                }}
                                                                            />
                                                                        </Grid>
                                                                    )
                                                                )}
                                                            </Grid>
                                                        </SortableContext>
                                                    </DndContext>
                                                )}
                                            </Grid>
                                            <Grid size={12}>
                                                <Grid container spacing={2}>
                                                    {selectedVariant && (
                                                        <Grid size={6}>
                                                            <Button fullWidth variant='outlined' startIcon={<Delete />} onClick={() => { handleDelete() }} className='transform btn-danger'>
                                                                Delete Varient
                                                            </Button>
                                                        </Grid>
                                                    )}
                                                    <Grid size={6} className='ms-auto'>
                                                        <Button fullWidth variant='outlined' type='submit' endIcon={<ArrowRightAlt />} className='transform btn-yellow'>
                                                            {selectedVariant ? "Save Changes" : "Add Veriant"}
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Form>
                                )
                            }}
                        </Formik>


                    </Box>
                </Grid>
            </Grid>
            <Dialog slotProps={{
                paper: {
                    sx: {
                        bgcolor: "var(--primary-color)",
                        color: "#fff",
                        boxShadow: "0px 0px 5px #FFFFFF",
                        height: 'fit-content',
                        width: '100%',
                        borderRadius: '10px'
                    },
                },
            }}
                open={opeaddProduct}>
                <Box className='p-3'>
                    <AddorUpdateProduct setOpenAddProduct={setOpenAddProduct} />
                </Box>
            </Dialog>
        </Box >

    )
}

export default VenderProducts
